import { IS_PRODUCTION, ANALYTIC_DEBUG_SHOW_LOG } from "utils/env-management"

export function loggingGroup(title: string, action: () => void, collapsed = false) {
    loggingGroupOpen(title, collapsed)
    try {
        action()
    } finally {
        loggingGroupClose()
    }
}

export function loggingGroupOpen(title: string, collapsed = false) {
    if (ANALYTIC_DEBUG_SHOW_LOG) {
        if (collapsed) {
            console.groupCollapsed(title)
        } else {
            console.group(title)
        }
    }
}

export function loggingGroupClose() {
    if (!IS_PRODUCTION) {
        console.groupEnd()
    }
}
